export default __webpack_public_path__ + "static/PaymentSection_es-dcff0a162400b10f48b30ff3a8e73e75.png";